(function($, window, document, s, undefined) {

  var initLettersLinks = function initLettersLinks() {
    s.$doc.on('click', ".sticky .letters", function letterLinkClick(e){
      e.preventDefault();
      var targetHeight = Math.floor(
        parseInt(
          $($(this).attr('href')).offset().top, 10
        )
      );

      $('html, body').animate({
        scrollTop: targetHeight - 125
      }, 600);
    });
  };

  var checkForMoreBuyingOptions = function checkForMoreBuyingOptions (){
    if (s.bodyId !== 'body-author-list') return;

    initLettersLinks();
  };

  s.callOnReady(checkForMoreBuyingOptions);

})(jQuery, this, this.document, window.s);
